import React, { HTMLAttributes } from "react";
import cn from "classnames";

export type CardHeaderProps = HTMLAttributes<HTMLDivElement>;

export const CardHeader = (props: CardHeaderProps) => {
  const { className, ...rest } = props;
  return <div className={cn("card-header", className)} {...rest} />;
};

export default CardHeader;
